import { combineReducers } from 'redux';

import * as types from 'modules/releases/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 *  releaseId: string | null,
 *  noteId: string | null,
 * }} ReleaseNoteModalReducer
 */

export default combineReducers({
  open: createReducer(false, {
    [LOCATION_CHANGE]: () => false,
    [types.OPEN_NOTE_MODAL]: () => true,
    [types.CLOSE_NOTE_MODAL]: () => false,
  }),
  releaseId: createReducer(null, {
    [LOCATION_CHANGE]: () => null,
    [types.CLOSE_NOTE_MODAL]: () => null,
    [types.OPEN_NOTE_MODAL]: (_, { payload }) => payload?.releaseId ?? null,
  }),
  noteId: createReducer(null, {
    [LOCATION_CHANGE]: () => null,
    [types.CLOSE_NOTE_MODAL]: () => null,
    [types.OPEN_NOTE_MODAL]: (_, { payload }) => payload?.noteId ?? null,
  })
});
